
// import React from "react";
// import "../App.css";
// import header from "../assests/images/about-2.jpg";
// import { useNavigate } from 'react-router-dom';
// import { 
//   Settings, 
//   CheckCircle, 
//   BrainCog, 
//   Database, 
//   PieChart, 
//   Map, 
//   Bot, 
//   Handshake, 
//   MessageCircle, 
//   Search, 
//   DraftingCompass, 
//   Rocket, 
//   LineChart, 
//   User,
//   RefreshCcw,
//   Check,
//   LifeBuoy,
//   Users,
//   TestTube,
//   Bug,
//   ShieldCheck,
//   Zap,
//   ClipboardList,
//   Cloud,
//   Cpu,
//   ShoppingCart,
//   Factory,
//   Plug,
//   Target,
//   Clock,
//   Wallet,
//   GitMerge,
//   GanttChart,
//   ChartBarDecreasing
  
// } from 'lucide-react';

// const Services = () => {
//   const navigate = useNavigate();
//   return (
//     <>
//       {/* Hero Header Section */}
//       <div
//         className="container-fluid page-header py-1 mb-2 wow fadeIn"
//         data-wow-delay="0.1s"
//         style={{
//           background: `linear-gradient(rgba(2, 74, 89, 0.8), rgba(2, 74, 89, 0.9)), url(${header})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           height: "30vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           position: "relative",
//         }}
//       >
//         <div className="container text-center">
//           <h1
//             className="display-5 mb-3 animated zoomIn"
//             style={{
//               color: "#FFA916",
//               fontWeight: "700",
//               textShadow: "3px 3px 6px rgba(0,0,0,0.3)",
//               letterSpacing: "2px",
//             }}
//           >
//             Comprehensive Business Solutions
//           </h1>
//           <p
//             className="lead wow fadeInUp"
//             data-wow-delay="0.3s"
//             style={{
//               color: "#fff",
//               fontSize: "1.4rem",
//               maxWidth: "800px",
//               margin: "0 auto",
//             }}
//           >
//             Transform your business operations with our end-to-end digital solutions and expert consultancy services
//           </p>
//         </div>
//       </div>

//       {/* Detailed Services Section */}
//       <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
//         <div className="container">
//           {/* Section Header */}
//           <div
//             className="wow fadeInUp"
//             data-wow-delay="0.1s"
//             style={{ textAlign: "center", marginBottom: "60px" }}
//           >
//             <h2
//               style={{
//                 color: "#024A59",
//                 fontWeight: "700",
//                 fontSize: "2.5rem",
//                 marginBottom: "30px",
//               }}
//             >
//               Our Services
//             </h2>
//           </div>

//           {/* Service Tabs */}
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "40px",
//             }}
//           >
//             {/* ERP Solutions */}
//             <div
//               className="wow fadeInLeft"
//               style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "15px",
//                 padding: "30px",
//                 boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
//                 position: "relative",
//                 overflow: "hidden",
//                 background: 'linear-gradient(135deg,rgb(50, 104, 117) 0%,rgb(132, 172, 180) 100%)',
//               }}
//             >
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "0",
//                   left: "0",
//                   right: "0",
//                   height: "5px",
//                   backgroundColor: "#FFA916",
//                 }}
//               ></div>
//               <h3
//                 style={{
//                   color: "#FFA916",
//                   marginBottom: "20px",
//                   fontSize: "1.8rem",
//                 }}
//               >
//                 <Settings 
//                   size={28} 
//                   color="#FFA916" 
//                   style={{ marginRight: "10px" }} 
//                 />
//                 ERP Implementation
//               </h3>
//               <ul
//                 style={{
//                   listStyle: "none",
//                   paddingLeft: "20px",
//                   marginBottom: "25px",
                  
//                 }}
//               >
//                 {[
//                   " Requirements gathering and analysis",
//                   "System Design",
//                   "Software Customization",
//                   "Software/System Testing",
//                   "Training",
//                   "Go Live"
//                 ].map((item, index) => (
//                   <li
//                     key={index}
//                     style={{
//                       marginBottom: "10px",
//                       position: "relative",
//                       color:'white'
//                     }}
//                   >
//                     <CheckCircle
//                       size={16}
//                       color="#FFA916"
//                       style={{
//                         position: "absolute",
//                         left: "-20px",
//                         top: "3px",
//                       }}
//                     />
//                     {item}
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Business Intelligence */}
//             <div
//               className="wow fadeInUp"
//               style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "15px",
//                 padding: "30px",
//                 boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
//                 background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)'
//               }}
//             >
//               <h3
//                 style={{
//                   color: "#024A59",
//                   marginBottom: "20px",
//                   fontSize: "1.8rem",
//                 }}
//               >
//                 <BrainCog 
//                   size={28} 
//                   color="#FFA916" 
//                   style={{ marginRight: "10px" }} 
//                 />
//                 Advanced Analytics
//               </h3>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "repeat(2, 1fr)",
//                   gap: "15px",
                  
//                 }}
//               >
//                 {[
//                   { icon: Database, text: "Data Warehousing" },
//                   { icon: PieChart, text: "Predictive Modeling" },
//                   { icon: Map, text: "Geospatial Analysis" },
//                   { icon: Bot, text: "AI-Powered Insights" },
//                 ].map((item, index) => (
//                   <div
//                     key={index}
//                     style={{
//                       backgroundColor: "#f8f9fa",
//                       color:'white',
//                       padding: "15px",
//                       borderRadius: "8px",
//                       textAlign: "center",
//                       background: 'linear-gradient(135deg,rgb(50, 104, 117) 0%,rgb(132, 172, 180) 100%)',
//                     }}
//                   >
//                     <item.icon
//                       size={24}
//                       color="#FFA916"
//                       strokeWidth={1.5}
//                     />
                    
//                     <p style={{ margin: "10px 0 0", color: "white" }}>
//                       {item.text}
//                     </p>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Consultancy */}
//             {/* <div
//               className="wow fadeInRight"
//               style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "15px",
//                 padding: "30px",
//                 boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
//                 background: 'linear-gradient(135deg,rgb(50, 104, 117) 0%,rgb(132, 172, 180) 100%)',
//               }}
//             >
//               <h3
//                 style={{
//                   color: "#FFA916",
//                   marginBottom: "20px",
//                   fontSize: "1.8rem",
//                 }}
//               >
//                 <Handshake 
//                   size={28} 
//                   color="#FFA916" 
//                   style={{ marginRight: "10px" }} 
//                 />
//                 Strategic Consultancy
//               </h3>
//               <div
//                 style={{
//                   borderLeft: "3px solid #FFA916",
//                   paddingLeft: "20px",
//                 }}
//               >
//                 <p
//                   style={{
//                     color: "white",
//                     fontStyle: "italic",
//                     marginBottom: "15px",
//                   }}
//                 >
//                   "We help you navigate digital transformation with proven frameworks and industry expertise"
//                 </p>
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <div
                  
//                     style={{
//                       width: "40px",
//                       height: "40px",
//                       borderRadius: "50%",
//                       backgroundColor: "#024A59",
//                       marginRight: "15px",
//                     }}
//                   > <User style={{color:'#FFA916'}}/></div>
//                   <div>
//                     <p style={{ margin: 0, fontWeight: "600", color: "white" }}>
//                       John Doe
//                     </p>
//                     <p style={{ margin: 0, fontSize: "0.9rem", color: "#FFA916" }}>
//                       Lead Consultant
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div> */}
            
//             {/* Training and Support */}
//             <div
//               className="wow fadeInLeft"
//               style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "15px",
//                 padding: "30px",
//                 boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
//                 position: "relative",
//                 overflow: "hidden",
//                 background: 'linear-gradient(135deg, rgb(86, 128, 64) 0%, rgb(164, 202, 138) 100%)',
//               }}
//             >
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "0",
//                   left: "0",
//                   right: "0",
//                   height: "5px",
//                   backgroundColor: "#FFA916",
//                 }}
//               ></div>
//               <h3
//                 style={{
//                   color: "#fff",
//                   marginBottom: "20px",
//                   fontSize: "1.8rem",
//                 }}
//               >
//                 <Users
//                   size={28} 
//                   color="#FFA916" 
//                   style={{ marginRight: "10px" }} 
//                 />
//                 Training & Support
//               </h3>
//               <ul
//                 style={{
//                   listStyle: "none",
//                   paddingLeft: "20px",
//                   marginBottom: "25px",
//                 }}
//               >
//                 {[
//                   "End-user training programs",
//                   "System administration training",
//                   "24/7 technical support",
//                   "Knowledge base access",
//                   "Continuous improvement workshops"
//                 ].map((item, index) => (
//                   <li
//                     key={index}
//                     style={{
//                       marginBottom: "10px",
//                       position: "relative",
//                       color: 'white'
//                     }}
//                   >
//                     <LifeBuoy
//                       size={16}
//                       color="#FFA916"
//                       style={{
//                         position: "absolute",
//                         left: "-20px",
//                         top: "3px",
//                       }}
//                     />
//                     {item}
//                   </li>
//                 ))}
//               </ul>
//             </div>
      
//             {/* Software Quality Assurance */}
//             <div
//               className="wow fadeInUp"
//               style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "15px",
//                 padding: "30px",
//                 boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
//                 background: 'linear-gradient(135deg, rgb(131, 58, 58) 0%, rgb(207, 121, 121) 100%)'
//               }}
//             >
//               <h3
//                 style={{
//                   color: "#fff",
//                   marginBottom: "20px",
//                   fontSize: "1.8rem",
//                 }}
//               >
//                 <TestTube 
//                   size={28} 
//                   color="#FFA916" 
//                   style={{ marginRight: "10px" }} 
//                 />
//                 Quality Assurance
//               </h3>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "repeat(2, 1fr)",
//                   gap: "15px",
//                 }}
//               >
//                 {[
//                   { icon: Bug, text: "Defect Tracking" },
//                   { icon: ShieldCheck, text: "Compliance Testing" },
//                   { icon: Zap, text: "Automation" },
//                   { icon: ClipboardList, text: "Test Planning" },
//                 ].map((item, index) => (
//                   <div
//                     key={index}
//                     style={{
//                       backgroundColor: "rgba(255, 255, 255, 0.15)",
//                       color: 'white',
//                       padding: "15px",
//                       borderRadius: "8px",
//                       textAlign: "center",
//                     }}
//                   >
//                     <item.icon
//                       size={24}
//                       color="#FFA916"
//                       strokeWidth={1.5}
//                     />
//                     <p style={{ margin: "10px 0 0", color: "white" }}>
//                       {item.text}
//                     </p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             {/* Project Management */}
// <div
//   className="wow fadeInRight"
//   style={{
//     backgroundColor: "#fff",
//     borderRadius: "15px",
//     padding: "30px",
//     boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
//     background: 'linear-gradient(135deg, rgb(85, 70, 112) 0%, rgb(148, 127, 184) 100%)',
//   }}
// >
//   <h3
//     style={{
//       color: "#FFA916",
//       marginBottom: "20px",
//       fontSize: "1.8rem",
//     }}
//   >
//     <GanttChart 
//       size={28} 
//       color="#FFA916" 
//       style={{ marginRight: "10px" }} 
//     />
//     Project Management
//   </h3>
//   <div
//     style={{
//       display: "flex",
//       flexDirection: "column",
//       gap: "15px",
//     }}
//   >
//     {[
//       { icon: Target, text: "Agile Methodology" },
//       { icon: Clock, text: "Timeline Management" },
//       { icon: Wallet, text: "Budget Control" },
//       { icon: GitMerge, text: "Change Management" },
//     ].map((item, index) => (
//       <div
//         key={index}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           backgroundColor: "rgba(255, 255, 255, 0.15)",
//           padding: "12px",
//           borderRadius: "8px",
//           color: "white"
//         }}
//       >
//         <item.icon size={20} color="#FFA916" style={{ marginRight: "10px" }} />
//         <span>{item.text}</span>
//       </div>
//     ))}
//   </div>
// </div>

// {/* Integrations */}
// <div
//   className="wow fadeInUp"
//   style={{
//     backgroundColor: "#fff",
//     borderRadius: "15px",
//     padding: "30px",
//     boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
//     background: 'linear-gradient(135deg, rgb(64, 98, 122) 0%, rgb(112, 169, 202) 100%)'
//   }}
// >
//   <h3
//     style={{
//       color: "#FFA916",
//       marginBottom: "20px",
//       fontSize: "1.8rem",
//     }}
//   >
//     <Plug
//       size={28} 
//       color="#FFA916" 
//       style={{ marginRight: "10px" }} 
//     />
//     System Integrations
//   </h3>
//   <div
//     style={{
//       display: "grid",
//       gridTemplateColumns: "repeat(3, 1fr)",
//       gap: "10px",
//       textAlign: "center",
//     }}
//   >
//     {[
//       { icon: Cloud, text: "Cloud APIs" },
//       { icon: Database, text: "Legacy Systems" },
//       { icon: Cpu, text: "IoT Devices" },
//       { icon: ShoppingCart, text: "eCommerce" },
//       { icon: MessageCircle, text: "CRM" },
//       { icon: Factory, text: "SCM" },
//     ].map((item, index) => (
//       <div
//         key={index}
//         style={{
//           padding: "10px",
//           borderRadius: "6px",
//           backgroundColor: "rgba(255, 255, 255, 0.15)",
//         }}
//       >
//         <item.icon size={20} color="#FFA916" />
//         <p style={{ margin: "5px 0 0", fontSize: "0.9rem", color: "white" }}>
//           {item.text}
//         </p>
//       </div>
//     ))}
//   </div>
// </div>

//           </div>

//           {/* Process Timeline */}
//           <div className="container-fluid py-5 bg-light">
//         <div className="container">
//           <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
//             <span 
//               className="d-inline-block rounded-pill px-4 py-1 mb-3"
//               style={{ backgroundColor: '#024A59', color: '#FFA916' }}
//             >
//               Our Methodology
//             </span>
//             <h1 className="display-6 mb-5" style={{ color: '#024A59' }}>
//               Structured for Success
//             </h1>
//           </div>
//           <div className="row g-4">
//             {[
//               {
//                 icon: MessageCircle,
//                 title: 'Consultation & Analysis',
//                 content: 'Engage in in-depth consultations to understand business goals and conduct needs analysis'
//               },
//               {
//                 icon: ChartBarDecreasing,
//                 title: 'Custom Solution Design',
//                 content: 'Develop personalized proposals with detailed project plans and timelines'
//               },
//               {
//                 icon: Settings,
//                 title: 'Implementation & QA',
//                 content: 'Execute seamless integration with rigorous quality assurance testing'
//               },
//               {
//                 icon: RefreshCcw,
//                 title: 'Support & Optimization',
//                 content: 'Provide ongoing support and continuous improvement through performance monitoring'
//               }
//             ].map((step, index) => (
//               <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay={`0.${index + 1}s`} key={index}>
//                 <div 
//                   className="process-step p-4 rounded h-100"
//                   style={{ 
//                     backgroundColor: 'white',
//                     boxShadow: '0 5px 15px rgba(0,0,0,0.08)',
//                     borderTop: `4px solid ${index % 2 === 0 ? '#024A59' : '#FFA916'}`
//                   }}
//                 >
//                   <div className="icon-box mb-3">
//                     <step.icon size={40} color={index % 2 === 0 ? '#024A59' : '#FFA916'} />
//                   </div>
//                   <h4 style={{ color: '#024A59' }}>{step.title}</h4>
//                   <p className="mb-0" style={{ color: 'black' }}>{step.content}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Implementation Process Section */}
//       <div className="container-fluid py-5">
//         <div className="container">
//           <div 
//             className="wow fadeInUp" 
//             data-wow-delay="0.1s"
//             style={{
//               marginTop: "40px",
//               position: "relative",
//               padding: "40px 0",
//             }}
//           >
//             <h3
//               className="text-center mb-5"
//               style={{
//                 color: "#024A59",
//                 fontSize: "2rem",
//                 fontWeight: "600"
//               }}
//             >
//               Our Implementation Journey
//             </h3>
//             <div
//               className="d-flex justify-content-between position-relative"
//               style={{ padding: '0 20px' }}
//             >
//               <div
//                 className="position-absolute"
//                 style={{
//                   top: "30%",
//                   left: "5%",
//                   right: "5%",
//                   height: "3px",
//                   backgroundColor: "#FFA916",
//                   zIndex: "1",
//                 }}
//               ></div>
//               {[
//                 { icon: MessageCircle, title: "Consaltation"},
//                 { icon: Search, title: "Requirement gathering and analysis"},
//                 { icon: DraftingCompass, title: "Design and Development"},
//                 { icon: Rocket, title: "Testing"},
//                 { icon: LineChart, title: "User Review"},
//                 { icon: LineChart, title: "Training"},
//                 { icon: LineChart, title: "Go-Live"},
//                 { icon: LineChart, title: "support & Improvement"}
//               ].map((step, index) => (
//                 <div
//                   key={index}
//                   className="text-center position-relative"
//                   style={{ zIndex: "2", width: "18%" }}
//                 >
//                   <div
//                     className="mx-auto mb-3"
//                     style={{
//                       width: "60px",
//                       height: "60px",
//                       backgroundColor: "#024A59",
//                       borderRadius: "50%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <step.icon
//                       color="white"
//                       size={24}
//                       strokeWidth={1.5}
//                     />
//                   </div>
//                   <h4
//                     style={{
//                       color: "#024A59",
//                       fontSize: "1.1rem",
//                       fontWeight: "600",
//                       minHeight: "50px"
//                     }}
//                   >
//                     {step.title}
//                   </h4>
//                   {index !== 4 && (
//                     <div
//                       className="position-absolute d-none d-lg-block"
//                       style={{
//                         right: "-40%",
//                         top: "30%",
//                         width: "50%",
//                         height: "2px",
//                         backgroundColor: "#FFA916"
//                       }}
//                     ></div>
//                   )}
//                 </div>
//               ))}
//             </div>
            
//           </div>
//         </div>
//       </div>
//         </div>
//       </div>

//       {/* CTA Section */}
//       <div
//         style={{
//           backgroundColor: "#FFA916",
//           padding: "80px 20px",
//           textAlign: "center",
//         }}
//       >
//         <div className="container">
//           <h2
//             style={{
//               color: "#024A59",
//               fontSize: "2.5rem",
//               marginBottom: "30px",
//               fontWeight: "700",
//             }}
//           >
//             Ready to Transform Your Business?
//           </h2>
//           <p
//             style={{
//               color: "#024A59",
//               fontSize: "1.2rem",
//               marginBottom: "40px",
//               maxWidth: "800px",
//               margin: "0 auto",
//             }}
//           >
//             Schedule a free consultation with our experts to discover how we can
//             optimize your business operations
//           </p>
//           <button
//             style={{
//               backgroundColor: "#024A59",
//               color: "#fff",
//               padding: "15px 40px",
//               borderRadius: "30px",
//               border: "none",
//               fontSize: "1.1rem",
//               fontWeight: "600",
//               cursor: "pointer",
//               transition: "all 0.3s ease",
//             }}
//             onMouseOver={(e) => {
//               e.target.style.backgroundColor = "#01303b";
//               e.target.style.transform = "translateY(-2px)";
//             }}
//             onMouseOut={(e) => {
//               e.target.style.backgroundColor = "#024A59";
//               e.target.style.transform = "translateY(0)";
//             }}
//             onClick={() => navigate("/contact")}
//           >
//             Get Started Now
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Services;


import React from "react";
import "../App.css";
import header from "../assests/images/about-2.jpg";
import NetworkIcon from '../assests/images/erp-infographic.jpg';
import ChartBarIcon from '../assests/images/Data Driven Solutions.jpg';
import LightbulbIcon from '../assests/images/Strategic Consultancy.jpg';
import { useNavigate } from 'react-router-dom';
import {
  CheckCircle,
  Database,
  PieChart,
  Map,
  Bot,
  FileText,
  BarChart3,
  Building2,
  MessageCircle,
  Search,
  DraftingCompass,
  Rocket,
  RefreshCcw,
  Bug,
  ShieldCheck,
  Zap,
  ClipboardList,
  Cloud,
  Cpu,
  ShoppingCart,
  Factory,
  Plug,
  ClipboardCheck,
  Code,
  DollarSign,
  CreditCard,
  Plane,
  Stethoscope
} from 'lucide-react';

const Services = () => {
  const navigate = useNavigate();

  const items = [
    { label: 'Education', icon: FileText, color: '#B10DC9' },
    { label: 'Reporting', icon: BarChart3, color: '#007bff' },
    { label: 'Finance', icon: DollarSign, color: '#ffdc00' },
    { label: 'Supply Chain', icon: ShoppingCart, color: '#7fdbff' },
    { label: 'Healthcare', icon: Stethoscope, color: '#2ecc40' },
    { label: 'Manufacturing', icon: Building2, color: '#39cccc' },
    { label: 'Tours & Travel', icon: Plane, color: '#3d9970' },
    { label: 'Human Resource', icon: CreditCard, color: '#ff851b' },
  ];

  const size = 400;
  const radius = 150;
  const center = size / 2;

  const gradientStops = items
    .map((it, i) => {
      const start = i * 45;
      const end = start + 45;
      return `${it.color} ${start}deg ${end}deg`;
    })
    .join(', ');

  return (
    <>
      {/* Hero Header Section */}
      <div
        className="container-fluid page-header py-1 mb-2 wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background: `linear-gradient(rgba(2, 74, 89, 0.8), rgba(2, 74, 89, 0.9)), url(${header})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "30vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <div className="container text-center">
          <h1
            className="display-5 mb-3 animated zoomIn"
            style={{
              color: "#FFA916",
              fontWeight: "700",
              textShadow: "3px 3px 6px rgba(0,0,0,0.3)",
              letterSpacing: "2px",
            }}
          >
            Comprehensive Business Solutions
          </h1>
          <p
            className="lead wow fadeInUp"
            data-wow-delay="0.3s"
            style={{
              color: "#fff",
              fontSize: "1.4rem",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            Transform your business operations with our end-to-end digital solutions and expert consultancy services
          </p>
        </div>
      </div>

      {/* Detailed Services Section */}
      <div style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container">
          {/* Section Header */}
          <div
            className="wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ textAlign: "center", }}
          >
            <h2
              style={{
                color: "#024A59",
                fontWeight: "700",
                fontSize: "2.5rem",
                marginBottom: "10px",
              }}
            >
              Our Services
            </h2>
          </div>
          <div
            className="row mb-3"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "30px",
            }}
          >
            {[
              {
                title: "Integrated ERP Solutions",
                text: "Our integrated ERP solutions are designed to streamline your business operations, from finance and human resources to supply chain management and customer relationship management. With our expertise in Microsoft ERP systems, we offer tailored solutions that meet your specific needs.",
                bg: "linear-gradient(135deg, rgb(50, 104, 117) 0%, rgb(132, 172, 180) 100%)",
                image: NetworkIcon,
              },
              {
                title: "Data Analytics",
                text: "Harness the power of data with our advanced analytics and digital transformation services. We help you unlock actionable insights from your data assets, enabling data-driven decision-making and innovation. Our solutions cover data collection, cleansing, modeling, and visualization.",
                bg: "linear-gradient(135deg, #4A90E2 0%, #50E3C2 100%)",
                image: ChartBarIcon,
              },
              {
                title: "Strategic Business Consultancy",
                text: "Our strategic business consultancy services help you navigate the complexities of the business landscape and make informed decisions that drive growth and profitability. We bring expertise in project management, business analysis, and functional consultancy.",
                bg: "linear-gradient(135deg, rgb(86, 128, 64) 0%, rgb(164, 202, 138) 100%)",
                image: LightbulbIcon,
              }
            ].map((block, index) => (
              <div
                key={index}
                className="wow fadeIn"
                style={{
                  padding: "30px",
                  borderRadius: "15px",
                  background: block.bg,
                  boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <img
                  src={block.image}
                  alt={block.title}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "50%",
                    marginBottom: "20px",
                    border: "3px solid #FFA916",
                    backgroundColor: "#fff"
                  }}
                />
                <h4 style={{ color: "#FFA916", marginBottom: "15px" }}>
                  {block.title}
                </h4>
                <p style={{ fontSize: "0.95rem" }}>{block.text}</p>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
            <div
              style={{
                position: 'relative',
                width: size,
                height: size,
                borderRadius: '50%',
                background: `conic-gradient(from -90deg, ${gradientStops})`
              }}
            >
              {/* dividing lines */}
              {items.map((_, i) => (
                <div
                  key={i}
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    width: '2px',
                    height: `${radius}px`,
                    backgroundColor: '#fff',
                    transformOrigin: '0 0',             // pivot at top-left
                    transform: `rotate(${i * 45 - 90}deg)`, // offset so first is at 12 o'clock
                    zIndex: 1
                  }}
                />
              ))}

              {/* icons + labels */}
              {items.map((it, i) => {
                const angle = (i + 0.5) * 45; // midpoint of segment
                const rad = (angle * Math.PI) / 180;
                const x = center + radius * Math.cos(rad);
                const y = center + radius * Math.sin(rad);
                const Icon = it.icon;

                return (
                  <div
                    key={i}
                    style={{
                      position: 'absolute',
                      left: x,
                      top: y,
                      transform: 'translate(-50%, -50%)',
                      textAlign: 'center',
                      zIndex: 2,
                      width: '80px'
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        width: '48px',
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                        margin: '0 auto'
                      }}
                    >
                      <Icon size={24} color={it.color} />
                    </div>
                    <div style={{ fontSize: '0.75rem', marginTop: '6px', color: '#024A59' }}>
                      {it.label}
                    </div>
                  </div>
                );
              })}

              {/* center label */}
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '140px',
                  height: '140px',
                  borderRadius: '50%',
                  backgroundColor: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  fontWeight: '700',
                  color: '#024A59',
                  fontSize: '1.1rem',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  zIndex: 3
                }}
              >
                ERP<br />System
              </div>
            </div>
          </div>
          {/* Service Tabs */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "40px",
            }}
          >

            {/* Business Intelligence */}
            <div
              className="wow fadeInUp"
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
                padding: "30px",
                boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
                background: 'linear-gradient(135deg, rgb(173, 161, 131) 0%, rgb(244, 219, 174) 100%)'
              }}
            >
              <h3
                style={{
                  color: "#024A59",
                  marginBottom: "20px",
                  fontSize: "1.8rem",
                }}
              >
                <BarChart3
                  size={28}
                  color="#FFA916"
                  style={{ marginRight: '10px' }}
                />
                Advanced Analytics

              </h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "15px",
                }}
              >
                {[
                  { icon: Database, text: "Real-Time Data Processing" },
                  { icon: PieChart, text: "Data Warehousing" },
                  { icon: Map, text: "Machine Learning & Forecasting" },
                  { icon: Bot, text: "AI-Powered Insights" },
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: "#f8f9fa",
                      color: 'white',
                      padding: "15px",
                      borderRadius: "8px",
                      textAlign: "center",
                      background: 'linear-gradient(135deg, rgb(50, 104, 117) 0%, rgb(132, 172, 180) 100%)',
                    }}
                  >
                    <item.icon
                      size={24}
                      color="#FFA916"
                      strokeWidth={1.5}
                    />
                    <p style={{ margin: "10px 0 0", color: "white" }}>
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Software Quality Assurance */}
            <div
              className="wow fadeInUp"
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
                padding: "30px",
                boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
                background: 'linear-gradient(135deg, rgb(131, 58, 58) 0%, rgb(207, 121, 121) 100%)'
              }}
            >
              <h3
                style={{
                  color: "#fff",
                  marginBottom: "20px",
                  fontSize: "1.8rem",
                }}
              >
                <ClipboardCheck
                  size={28}
                  color="#FFA916"
                  style={{ marginRight: '10px' }}
                />
                Quality Assurance
              </h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "15px",
                }}
              >
                {[
                  { icon: Bug, text: "Defect Tracking" },
                  { icon: ShieldCheck, text: "Compliance Testing" },
                  { icon: Zap, text: "Automation" },
                  { icon: ClipboardList, text: "Test Planning" },
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.15)",
                      color: 'white',
                      padding: "15px",
                      borderRadius: "8px",
                      textAlign: "center",
                    }}
                  >
                    <item.icon
                      size={24}
                      color="#FFA916"
                      strokeWidth={1.5}
                    />
                    <p style={{ margin: "10px 0 0", color: "white" }}>
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Integrations */}
            <div
              className="wow fadeInUp"
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
                padding: "30px",
                boxShadow: "0 10px 30px rgba(2, 74, 89, 0.1)",
                background: 'linear-gradient(135deg, rgb(64, 98, 122) 0%, rgb(112, 169, 202) 100%)'
              }}
            >
              <h3
                style={{
                  color: "#FFA916",
                  marginBottom: "20px",
                  fontSize: "1.8rem",
                }}
              >
                <Plug
                  size={28}
                  color="#FFA916"
                  style={{ marginRight: "10px" }}
                />
                System Integrations
              </h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "10px",
                  textAlign: "center",
                }}
              >
                {[
                  { icon: Cloud, text: "Cloud & API Services " },
                  { icon: Database, text: "Mobile & Edge Integrations" },
                  { icon: Cpu, text: "Power Platform & Low-Code Tools" },
                  { icon: ShoppingCart, text: "Legacy & Hybrid Systems" },
                  { icon: MessageCircle, text: "Business Applications (CRM, SCM, HRMS) " },
                  { icon: Factory, text: " Commerce & Customer Platforms" },
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "10px",
                      borderRadius: "6px",
                      backgroundColor: "rgba(255, 255, 255, 0.15)",
                    }}
                  >
                    <item.icon size={20} color="#FFA916" />
                    <p style={{ margin: "5px 0 0", fontSize: "0.9rem", color: "white" }}>
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Process Timeline */}
          <div className="container-fluid py-2 mb-3 bg-light">
            <div className="container">
              <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <span
                  className="d-inline-block rounded-pill px-4 py-2 mb-3 mt-3"
                  style={{ backgroundColor: '#024A59', color: '#FFA916' }}
                >
                  Our Methodology
                </span>
                <h1 className="display-6 mb-2" style={{ color: '#024A59' }}>
                  Structured for Success
                </h1>
              </div>
              <div className="row g-4">
                {[
                  {
                    icon: Search,
                    title: 'Discover',
                    content: 'Understand business objectives, challenges, and define requirements through workshops and analysis'
                  },
                  {
                    icon: DraftingCompass,
                    title: 'Design',
                    content: 'Craft user-centric solutions with wireframes and workflows tailored to your needs'
                  },
                  {
                    icon: Code,
                    title: 'Develop',
                    content: 'Build incrementally using Agile sprints, ensuring transparency and adaptability'
                  },
                  {
                    icon: CheckCircle,
                    title: 'Test',
                    content: 'Ensure quality with comprehensive testing phases, including UAT and security checks'
                  },
                  {
                    icon: Rocket,
                    title: 'Deploy',
                    content: 'Roll out seamlessly with training and support for confident adoption'
                  },
                  {
                    icon: RefreshCcw,
                    title: 'Improve',
                    content: 'Continuously optimize post-launch with monitoring and iterative enhancements'
                  }
                ].map((step, index) => (
                  <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`0.${index + 1}s`} key={index}>
                    <div
                      className="process-step p-4 rounded h-100"
                      style={{
                        backgroundColor: 'white',
                        boxShadow: '0 5px 15px rgba(0,0,0,0.08)',
                        borderTop: `4px solid ${index % 2 === 0 ? '#024A59' : '#FFA916'}`
                      }}
                    >
                      <div className="icon-box mb-3">
                        <step.icon size={40} color={index % 2 === 0 ? '#024A59' : '#FFA916'} />
                      </div>
                      <h4 style={{ color: '#024A59' }}>{step.title}</h4>
                      <p className="mb-0" style={{ color: 'black' }}>{step.content}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Implementation Process Section
          <div className="container-fluid py-2 bg-light">
            <div className="container">
              <div 
                className="wow fadeInUp" 
                data-wow-delay="0.1s"
                style={{
                  position: "relative",
               
                }}
              >
                <h3
                  className="text-center"
                  style={{
                    color: "#024A59",
                    fontSize: "2rem",
                    fontWeight: "600"
                  }}
                >
                  Our Implementation Circle
                </h3>
                
             
                <div className="position-relative mx-auto" style={{ 
                  width: "100%", 
                  maxWidth: "800px", 
                  height: "800px",
                  margin: "0 auto" 
                }}>
                 
                  <svg 
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      transform: "rotate(-90deg)"
                    }}
                  >
                    {[...Array(8)].map((_, index) => {
                      const angle = (index * 45) - 45;
                      const nextAngle = ((index + 1) * 45) - 45;
                      const radius = 300;
                      
                      const x1 = 400 + radius * Math.cos(angle * Math.PI / 180);
                      const y1 = 400 + radius * Math.sin(angle * Math.PI / 180);
                      const x2 = 400 + radius * Math.cos(nextAngle * Math.PI / 180);
                      const y2 = 400 + radius * Math.sin(nextAngle * Math.PI / 180);

                      return (
                        <path
                          key={index}
                          d={`M ${x1} ${y1} Q 400 400 ${x2} ${y2}`}
                          fill="none"
                          stroke="#FFA916"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      );
                    })}
                  </svg>

                 
                  <div className="position-relative" style={{ width: "100%", height: "100%" }}>
                    {[
                      
                      { icon: Search, title: "Requirement Analysis" },
                      { icon: DraftingCompass, title: "Design & Development" },
                      { icon: Rocket, title: "Testing" },
                      { icon: LineChart, title: "User Review" },
                      { icon: Users, title: "Training" },
                      { icon: Cloud, title: "Go-Live" },
                      { icon: RefreshCcw, title: "Support & Improvement" },
                      { icon: MessageCircle, title: "Consultation" },
                    ].map((step, index) => {
                      const angle = (index * 45) - 45;
                      const radius = 300;
                      const x = 400 + radius * Math.cos(angle * Math.PI / 180);
                      const y = 400 + radius * Math.sin(angle * Math.PI / 180);

                      return (
                        <div
                          key={index}
                          className="text-center position-absolute"
                          style={{
                            transform: `translate(${x - 50}px, ${y - 50}px)`,
                            width: "100px",
                            transition: "all 0.3s ease"
                          }}
                        >
                          <div
                            className="mx-auto mb-3"
                            style={{
                              width: "60px",
                              height: "60px",
                              backgroundColor: "#024A59",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 4px 15px rgba(2, 74, 89, 0.2)"
                            }}
                          >
                            <step.icon
                              color="white"
                              size={24}
                              strokeWidth={1.5}
                            />
                          </div>
                          <h4
                            style={{
                              color: "#024A59",
                              fontSize: "1rem",
                              fontWeight: "600",
                              minHeight: "50px",
                              lineHeight: "1.3"
                            }}
                          >
                            {step.title}
                          </h4>
                        </div>
                      );
                    })}
                  </div>

                
                  <div 
                    className="position-absolute rounded-circle d-flex align-items-center justify-content-center wow zoomIn"
                    data-wow-delay="0.4s"
                    style={{
                      width: "200px",
                      height: "200px",
                      backgroundColor: "#FFA916",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      boxShadow: "0 10px 30px rgba(255, 169, 22, 0.3)"
                    }}
                  >
                    <div className="text-center text-white">
                      <h4 style={{ fontWeight: "600", marginBottom: "8px" }}>Process</h4>
                      <p className="mb-0" style={{ fontSize: "0.9rem" }}>8 Strategic Steps</p>
                      <p className="mb-0" style={{ fontSize: "0.9rem" }}>to Success</p>
                    </div>
                  </div>
                </div>
              </div>
        </div>
      </div> */}
        </div>
      </div>
      {/* CTA Section */}
      <div
        style={{
          backgroundColor: "#FFA916",
          padding: "80px 20px",
          textAlign: "center",
        }}
      >
        <div className="container">
          <h2
            style={{
              color: "#024A59",
              fontSize: "2.5rem",
              marginBottom: "30px",
              fontWeight: "700",
            }}
          >
            Ready to Transform Your Business?
          </h2>
          <p
            style={{
              color: "#024A59",
              fontSize: "1.2rem",
              marginBottom: "40px",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            Schedule a free consultation with our experts to discover how we can
            optimize your business operations
          </p>
          <button
            style={{
              backgroundColor: "#024A59",
              color: "#fff",
              padding: "15px 40px",
              borderRadius: "30px",
              border: "none",
              fontSize: "1.1rem",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#01303b";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#024A59";
              e.target.style.transform = "translateY(0)";
            }}
            onClick={() => navigate("/contact")}
          >
            Get Started Now
          </button>
        </div>
      </div>
    </>
  );
};

export default Services;